import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-300 mb-4"
          style={{ fontFamily: 'IBM Plex Mono, monospace' }}>404</p>
        <h1 className="text-[80px] font-semibold text-slate-900 leading-none mb-4">
          Lost.
        </h1>
        <p className="text-[16px] text-slate-400 font-light mb-8">
          This page doesn't exist or has been moved.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-slate-900 text-white font-semibold text-sm rounded-full hover:bg-slate-700 transition-colors"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}